/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_JoinInputs */

const th_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าร่วมการประชุม`)
};

const en_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the meeting`)
};

const ja_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミーティングに参加`)
};

const zh_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入会议`)
};

const es_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unirse a la reunión`)
};

const pt_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar na reunião`)
};

const id_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gabung pertemuan`)
};

const fr_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre la réunion`)
};

const tl_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumali sa miting`)
};

const vi_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vào họp`)
};

const ko_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`회의 참여`)
};

const de_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting beitreten`)
};

const ru_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти во встречу`)
};

const tr_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplantıya katıl`)
};

const it_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra nella riunione`)
};

const pl_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dołącz do spotkania`)
};

const uk_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приєднатися до зустрічі`)
};

const hi_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैठक में शामिल हों`)
};

const ar_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الانضمام إلى الاجتماع`)
};

const ms_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertai mesyuarat`)
};

const bn_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সভায় যোগ দিন`)
};

const zh_tw2_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入會議`)
};

const zh_hk2_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入會議`)
};

const ur_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملاقات میں شامل ہوں`)
};

const fa_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پیوستن به جلسه`)
};

const sw_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jiunge na mkutano`)
};

const nl_meeting_join = /** @type {(inputs: Meeting_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deelnemen aan gesprek`)
};

/**
* | output |
* | --- |
* | "Join the meeting" |
*
* @param {Meeting_JoinInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_join = /** @type {((inputs?: Meeting_JoinInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_JoinInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_join(inputs)
	if (locale === "ja") return ja_meeting_join(inputs)
	if (locale === "zh") return zh_meeting_join(inputs)
	if (locale === "es") return es_meeting_join(inputs)
	if (locale === "pt") return pt_meeting_join(inputs)
	if (locale === "id") return id_meeting_join(inputs)
	if (locale === "fr") return fr_meeting_join(inputs)
	if (locale === "tl") return tl_meeting_join(inputs)
	if (locale === "vi") return vi_meeting_join(inputs)
	if (locale === "ko") return ko_meeting_join(inputs)
	if (locale === "de") return de_meeting_join(inputs)
	if (locale === "ru") return ru_meeting_join(inputs)
	if (locale === "tr") return tr_meeting_join(inputs)
	if (locale === "it") return it_meeting_join(inputs)
	if (locale === "pl") return pl_meeting_join(inputs)
	if (locale === "uk") return uk_meeting_join(inputs)
	if (locale === "hi") return hi_meeting_join(inputs)
	if (locale === "ar") return ar_meeting_join(inputs)
	if (locale === "ms") return ms_meeting_join(inputs)
	if (locale === "bn") return bn_meeting_join(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_join(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_join(inputs)
	if (locale === "ur") return ur_meeting_join(inputs)
	if (locale === "fa") return fa_meeting_join(inputs)
	if (locale === "sw") return sw_meeting_join(inputs)
	if (locale === "nl") return nl_meeting_join(inputs)
	return en_meeting_join(inputs)
});